module.exports = __webpack_public_path__ + "static/img/logo-dark.203b18f7.png";